// extracted by mini-css-extract-plugin
export var cardContainer = "_rc-0";
export var cardHeader = "_rc-2";
export var collapsedState = "_rc-3";
export var dragHandle = "_rc-5";
export var dragHandleIcon = "_rc-6";
export var dragging = "_rc-1";
export var titleArea = "_rc-4";